(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('azureDao', ["http", function (http) {
        return {
            subscriptions: function () {
                return http.get('/api/v1/ms_azure/subscriptions');
            },
            activityLogs: function (params) {
                return http.get('/api/v1/ms_azure/activity_logs').params(params);
            },
            eventCategorySeverity: function () {
                return http.get('/api/v1/ms_azure/event_category_severity');
            },
            resourceTypes: function () {
                return http.get('/api/v1/ms_azure/resource_types');
            },
            resourceGroups: function (params) {
                return http.get('/api/v1/ms_azure/resource_groups').params(params);
            },
            resources: function (params) {
                return http.get('/api/v1/ms_azure/resources').params(params);
            }
        };
    }]);
}());